import { genApiAxios } from "./axiosInstance";
import { store } from "store/store";
import { logout } from "store/authReducer";

// function timeout(delay) {
//   return new Promise((res) => setTimeout(res, delay));
// }

const { dispatch } = store;

export const genApiData = {
  post: async (path, params, cancelToken) =>
    genApiAxios
      .post(`${path}`, params, {
        cancelToken: cancelToken?.token,
      })
      .then((res) => {
        return res?.data;
      })
      .catch((err) => {
        console.log(err);
        if (err?.response?.status === 401) dispatch(logout());
        throw err.error ? err : err?.response;
      }),
};

export const reportApiData = {
  post: async (path, params, options, cancelToken) =>
    genApiAxios
      .post(`/Report${path}`, params, {
        ...options,
        cancelToken: cancelToken?.token,
      })
      .then((res) => {
        return res?.data;
      })
      .catch((err) => {
        console.log(err);
        throw err.error ? err : err?.response;
      }),
};

export const getGenApiData = async (params) =>
  genApiData.post("/GetData", params);

export const getReportApiData = async (params, options) =>
  reportApiData.post("/GetPDF", params, options);
